/**
 * Storefront homepage sections (linker-commerce) that can be shown/hidden and
 * reordered from the admin. Keys must stay in sync with
 * linker-commerce/site/src/lib/homepage-sections.ts.
 *
 * The order here is the storefront's default order.
 */
export const HOMEPAGE_SECTION_KEYS = Object.freeze([
	'categoryCards',
	'hajj',
	'water',
	'largeBanner',
	'haram',
	'mosqueCare',
	'subscriptions',
]);

/**
 * Tenants whose storefront reads the homepage sections config.
 * The management UI is only shown to these tenants.
 */
export const HOMEPAGE_SECTIONS_TENANTS = Object.freeze([494]);

export function canManageHomepageSections(tenantId) {
	return HOMEPAGE_SECTIONS_TENANTS.includes(Number(tenantId));
}

export function getDefaultHomepageSections() {
	return HOMEPAGE_SECTION_KEYS.map((key) => ({ key, visible: true }));
}

/**
 * Normalises a stored `sections` array: drops unknown/duplicate keys and
 * appends any missing section (visible) at the end. Falls back to the
 * defaults when nothing usable is stored.
 */
export function normalizeHomepageSections(raw) {
	if (!Array.isArray(raw)) return getDefaultHomepageSections();

	const seen = new Set();
	const sections = [];
	for (const item of raw) {
		const key = item?.key;
		if (!HOMEPAGE_SECTION_KEYS.includes(key) || seen.has(key)) continue;
		seen.add(key);
		sections.push({ key, visible: item.visible !== false });
	}

	if (sections.length === 0) return getDefaultHomepageSections();

	for (const key of HOMEPAGE_SECTION_KEYS) {
		if (!seen.has(key)) sections.push({ key, visible: true });
	}
	return sections;
}
